import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Mail, CheckCircle2 } from 'lucide-react';
export function StrongClose() {
  return <section className="py-24 px-6 bg-navy-900 border-b border-navy-800" data-id="element-19">
      <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-20">
        <h2 className="text-4xl md:text-5xl font-serif text-cream leading-tight" data-id="element-21">
          You've been living with this long enough.
        </h2>

        <div className="space-y-6 text-lg text-cream-300/80" data-id="element-22">
          <p data-id="element-23">
            You know the routine. The shifting. The sighing. The 3AM ceiling
            stare. The morning you start already tired.
          </p>
          <p data-id="element-24">You've tried the things they told you to try. And here you are.</p>
          <p data-id="element-25">Still reading. Still searching. Still in pain.</p>
          <p className="text-xl font-serif text-cream italic" data-id="element-26">
            Which means you know, somewhere deep down, that the answer hasn't
            arrived yet.
          </p>
          <p className="text-2xl font-bold text-teal-400" data-id="element-27">Until now.</p>
        </div>

        <div className="bg-navy-800 p-8 rounded-2xl border border-navy-700 my-12 text-left space-y-4" data-id="element-28">
          <p className="text-cream-300/90" data-id="element-29">
            The 11PM Spine Reset is not a miracle. It's a method.
          </p>
          <p className="text-cream-300/90" data-id="element-30">
            A precise, sequenced, science-backed method that attacks your pain
            where it actually lives — in the nervous system loop that runs on
            autopilot every night while you're trying to sleep.
          </p>
          <p className="text-cream font-bold" data-id="element-31">
            12 minutes. A yoga mat. A tennis ball. And the knowledge that
            tonight could genuinely be different.
          </p>
        </div>

        <div className="space-y-4" data-id="element-32">
          <p className="text-2xl font-serif text-cream" data-id="element-33">
            You deserve to sleep. You deserve to wake up without pain. You
            deserve your life back.
          </p>
          <p className="text-xl text-teal-400 font-bold" data-id="element-34">
            And it starts tonight.
          </p>
          <p className="text-cream-300/60" data-id="element-35">
            For less than the cost of one chiropractic co-pay.
          </p>
        </div>
      </div>
    </section>;
}
export function FinalCTA() {
  return <section id="final-cta" className="py-24 px-6 bg-navy-900 relative overflow-hidden" data-id="element-36">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-500/10 rounded-full blur-[100px] pointer-events-none" data-id="element-37" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-38">
        <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-teal-500/30 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-39">
          <div className="text-center mb-10" data-id="element-40">
            <h2 className="text-3xl md:text-5xl font-serif text-cream mb-4" data-id="element-41">
              YES — I WANT TO SLEEP PAIN-FREE TONIGHT
            </h2>
            <p className="text-xl text-teal-400 font-medium" data-id="element-42">
              Get Instant Access To The Complete 11PM Spine Reset System
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center mb-10" data-id="element-43">
            <div className="relative" data-id="element-44">
              <img src="https://cdn.magicpatterns.com/uploads/mdPNgk2XAGWNJRTnFmS9qf/The_11pm_Spine_Reset_eBook_Cover.png" alt="The 11PM Spine Reset System" className="w-full max-w-sm mx-auto rounded-xl shadow-2xl border border-white/10" data-id="element-45" />
            </div>

            <div className="space-y-4" data-id="element-46">
              <div className="flex items-center gap-3 text-cream-300/90" data-id="element-47">
                <CheckCircle2 className="w-6 h-6 text-teal-400 shrink-0" data-id="element-48" />
                <span data-id="element-49">The Complete 11PM Spine Reset Guide</span>
              </div>
              <div className="flex items-center gap-3 text-cream-300/90" data-id="element-50">
                <CheckCircle2 className="w-6 h-6 text-teal-400 shrink-0" data-id="element-51" />
                <span data-id="element-52">Bonus #1: Visual Action Map</span>
              </div>
              <div className="flex items-center gap-3 text-cream-300/90" data-id="element-53">
                <CheckCircle2 className="w-6 h-6 text-teal-400 shrink-0" data-id="element-54" />
                <span data-id="element-55">Bonus #2: 3-Day Relief Tracker</span>
              </div>
              <div className="flex items-center gap-3 text-cream-300/90" data-id="element-56">
                <CheckCircle2 className="w-6 h-6 text-teal-400 shrink-0" data-id="element-57" />
                <span data-id="element-58">Bonus #3: Desk-Side Mini Reset</span>
              </div>
              <div className="flex items-center gap-3 text-cream font-bold pt-4 border-t border-navy-700" data-id="element-59">
                <ShieldCheck className="w-6 h-6 text-gold-500 shrink-0" data-id="element-60" />
                <span data-id="element-61">60-Day "Sleep Through The Night" Guarantee</span>
              </div>
            </div>
          </div>

          <div className="text-center space-y-6" data-id="element-62">
            <a href="https://www.shopdilore.com/cart/54028549095734:1" target="_blank" rel="noopener noreferrer" className="inline-block w-full md:w-auto bg-teal-500 hover:bg-teal-400 text-navy-900 font-black text-2xl py-6 px-12 rounded-xl shadow-[0_0_40px_rgba(20,184,166,0.3)] hover:shadow-[0_0_60px_rgba(20,184,166,0.5)] transition-all transform hover:-translate-y-1" data-id="element-63">
              GET INSTANT ACCESS FOR JUST $6.39 →
            </a>

            <p className="text-cream-300/70 font-medium" data-id="element-64">
              Instant download. Works on any device. Start your protocol
              tonight.
            </p>

            <div className="flex flex-wrap justify-center items-center gap-6 text-sm text-cream-300/50 pt-4" data-id="element-65">
              <div className="flex items-center gap-2" data-id="element-66">
                <ShieldCheck className="w-4 h-4" data-id="element-67" />
                <span data-id="element-68">Secured by SSL encryption</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-69">
                <CreditCard className="w-4 h-4" data-id="element-70" />
                <span data-id="element-71">All major cards accepted</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-72">
                <Mail className="w-4 h-4" data-id="element-73" />
                <span data-id="element-74">Instant delivery to your inbox</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}